import { isDefined } from "../../helper/utils";

Vue.component("last-seen-item-list-seepra", {

    template: `<div class="row" v-show="items.length">
        <div class="col-12">
            <slot name="heading"></slot>
        </div>

        <div class="col-12">
            <carousel-seepra :items-per-page="itemsPerPage"
                :items-per-page-xs="itemsPerPageXs"
                :items-per-page-sm="itemsPerPageSm"
                :items-per-page-md="itemsPerPageMd "
                :items-per-page-lg="itemsPerPageLg "
                :items-per-page-xll="itemsPerPageXll"
                :disable-carousel="disableCarousel">
                <template slot="items" v-for="item in items">
                    <category-item
                        :key="item.id"
                        :item-data="item.data"
                        :decimal-count="$ceres.config.item.storeSpecial"
                        :disable-carousel-on-mobile="items.length > itemsPerPage"
                        :padding-classes="paddingClasses"
                        :padding-inline-styles="paddingInlineStyles">
                    <template #before-prices>
                        <div v-html="getContainerContentById(item.id, 'beforePrices')"></div>
                    </template>
                    <template #after-prices>
                        <div v-html="getContainerContentById(item.id, 'afterPrices')"></div>
                    </template>
                    </category-item>
                </template>
            </carousel-seepra>
        </div>
    </div>`,

    props:
    {
        itemsPerPage:
        {
            type: Number,
            default: 5
        },
        itemsPerPageXs:
        {
            type: Number,
            default: 1
        },
        itemsPerPageSm:
        {
            type: Number,
            default: 2
        },
        itemsPerPageMd:
        {
            type: Number,
            default: 3
        },
        itemsPerPageLg:
        {
            type: Number,
            default: 4
        },
        itemsPerPageXll: {
            type: Number,
            default: 5
        },
        disableCarousel:
        {
            type: Boolean,
            default: false
        },

        maxItems:
        {
            type: Number,
            default: 4
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    computed: window.Vuex.mapState({
        items(state)
        {
            return state.lastSeen.lastSeenItems.slice(0, this.maxItems);
        },
        containers: state => state.lastSeen.containers
    }),

    beforeMount()
    {
        this.$store.dispatch("getLastSeenItems");
    },

    methods:
    {
        getContainerContentById(variationId, containerKey)
        {
            const containersById = this.containers[variationId];

            if (isDefined(containersById))
            {
                const container = containersById[containerKey];

                if (isDefined(container))
                {
                    return container;
                }
            }

            return "";
        }
    }
});
